// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"UR-z","categoryName":"VR-z","categoryImage":"WR-z","categoryContent":"XR-z","bottomAligned":"YR-z"};